import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import { Role } from '../_models/role';

import { environment } from '../../environments/environment';

@Injectable()
export class RoleService {
  constructor(private http: Http) { }

  getAll(): Promise<Role[]> {
      return this.http.get(environment.apiUrl + 'roles')
              .toPromise()
              .then((response: Response) => response.json())
              .catch(x => console.log(x));
  }
}




// WEBPACK FOOTER //
// ./src/app/_services/role.service.ts